import CascadeFilter from "@home/components/CascadeFilter";
import React from "react";
// import { useIntl } from "umi";

export const renderRegion = (props: any): React.ReactElement => {
  const { key, value, options, onChange, locale, getLocalText, name, allInfo, lftName, rtName, hasKeyChange = false, ...restProps } = props || {};
  return <CascadeFilter
    value={value}
    language={null}
    className={'search-items-country'}
    showBubble={true}
    onChange={(value) => hasKeyChange ? onChange(key, value) : onChange(value)}
    options={options}
    locale={locale}
    regionType = 'region'
    marketType = 'market'
    // boxClassName={classNames("dbd-cascade-filter-select-drop-down-box-hide-left-all",
    //   { 'dbd-benchmark-metrics-selector-box': isEN }
    // )}
    {...restProps}
  />;

};
